import {
  Box,
  Typography,
  TextField,
  styled,
  InputAdornment,
  Tooltip,
} from "@mui/material";
import React from "react";
import TaskAltIcon from "@mui/icons-material/TaskAlt";

const CustomTextField = styled(TextField)(({ theme }) => ({
  "& .MuiInputBase-root": {
    minHeight: "30px", // or any fixed height you prefer
    padding: 0,
    display: "flex",
    alignItems: "center",
  },
  "& .MuiOutlinedInput-root": {
    padding: "10px", // removes root padding
  },
  "& .MuiOutlinedInput-input": {
    padding: "2px 4px", // adjust this if needed
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    top: 0,
  },
  "&.highlight-disabled .MuiInputBase-input.Mui-disabled": {
    color: "#090808",
    cursor: "not-allowed",
    opacity: 1,
  },
  "& .MuiInputBase-input.Mui-disabled": {
    color: "#090808",
  },
}));

const EllipsisInputField = ({
  title,
  adornmentText,
  handleChange,
  placeholder,
  value,
  errors,
  disabled,
  fieldName,
  showIcon,
  mt,
}) => {
  return (
    <Box>
      <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 0.3 }}>
        {title}
      </Typography>
      <Tooltip title={value || ""} arrow>
        <CustomTextField
          sx={{ mt: mt, padding: 0 }}
          variant="outlined"
          value={value || ""}
          disabled={disabled}
          onChange={handleChange}
          fullWidth
          name={fieldName}
          placeholder={placeholder}
          error={!!errors}
          className={disabled ? "highlight-disabled" : ""}
          multiline={false} // always single-line for ellipsis
          InputLabelProps={{
            style: { color: errors ? "#D34040" : undefined },
          }}
          InputProps={{
            endAdornment:
              (showIcon && (
                <TaskAltIcon sx={{ color: "green", padding: 0 }} />
              )) ||
              (adornmentText && (
                <InputAdornment position="end">
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      minWidth: "10px",
                      padding: 0,
                    }}
                  >
                    <Box
                      sx={{
                        height: "10px",
                        width: "1px",
                        bgcolor: "#8A8A8A",
                        marginRight: "8px",
                        padding: 0,
                      }}
                    />
                    {adornmentText}
                  </Box>
                </InputAdornment>
              )),
          }}
        />
      </Tooltip>
      {errors && typeof errors === "string" && (
        <Typography variant="body2" color="#D34040">
          {errors}
        </Typography>
      )}
    </Box>
  );
};

export default EllipsisInputField;
